/*
 * メッセージ用 アコーディオンパネル 定義コンポーネント
 * 共通部品
 */
<template>
	<div>
		<div v-if="disp_isMessage" >
			<div v-if="disp_isErrorExt" class="error-messages">
				<c-message-list 
					:r_errors="error_messages.ext[0].errors" >
				</c-message-list>
			</div>
			<div v-else v-bind:class="{'success-messages': !disp_isError, 'error-messages': disp_isError }">
				<span v-html="error_messages.errmessage"></span>
			</div>
		</div>
	</div>
</template>
<script>
	/**
	 * メッセージ用 アコーディオンパネル 定義コンポーネント.<br>
	 * @module js\parts_unit\MessageAccordion
	 * @example
	 * <c-message-accordion
	 * 	:messages = "{{$messages}}" 
	 * 	:error_messages = "m_message" 
	 * >
	 * </c-message-accordion>
	 **/

	/**
	 * props 引数
	 * @param {string[]} messages - 表示文言
	 * @param {string[]} error_messages - エラーメッセージ
	 **/
	 export default {
		props:[
			'error_messages',
		],
		/**
		 * @prop {bool} disp_isError - エラーチェック
		 * @instance
		 **/
		computed: {
			/*
			 * エラーチェック
			 */
			disp_isErrorExt: function() {
				if ( this.error_messages.ext 
						&& this.error_messages.ext[0] 
						&& this.error_messages.ext[0]["errors"]) {
					return true;
				}
				return false;
			},
			/*
			 * エラーチェック
			 */
			disp_isError: function() {
				if ( typeof this.error_messages === "object" &&
						typeof this.error_messages.result === 'number' &&
						this.error_messages.result != 0 ) {
					// エラー
					return true;
				}
				return false;
			},
			/*
			 * メッセージチェック
			 */
			disp_isMessage: function() {
				// 文字列形式メッセージかどうか
				if (typeof this.error_messages.errmessage === 'string' &&
						this.error_messages.errmessage !== "" ) {
					// 改行コードを<br>に置換
					this.error_messages.errmessage = this.error_messages.errmessage.replace(/\r?\n/g, '<br>');
					return true;
				}
				return false;
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * myはローカルコンポーネント <br>
		 * @prop {component} c-messagelist - ページネーションコンポーネント
		 * @instance
		 **/
		components: {
			/*
			'my-messagelist': require('js/parts_unit/MessageList.vue')
			*/
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/viewMessageDetail.vue